import { z } from 'zod';

// ─── List search schema ────────────────────────────────────────────────────────

export const productionsListSearch = z.object({
  tab: z.string().catch('productions'),
  page: z.number().int().min(0).catch(0),
  count: z.number().int().min(10).max(500).catch(20),
  sort: z.string().optional(),
  filters: z.record(z.array(z.string())).optional(),
  // Processes tab state
  pPage: z.number().int().min(0).catch(0),
  pCount: z.number().int().min(10).max(500).catch(20),
  pFilters: z.record(z.array(z.string())).optional(),
});

export type ProductionsListSearch = z.infer<typeof productionsListSearch>;

// ─── List meta ──────────────────────────────────────────────────────────────────

export interface ProductionsListMeta {
  total: number;
  page: number;
  count: number;
  lastPage?: number;
}
